export const isDayOrDaysText = (daysQnt ) => {
    return daysQnt <= 1 ? "dia" : "dias"
}